import {createFeatureSelector, createSelector} from '@ngrx/store';
import {IMailerDomainState} from '@app/stores/mailer-domain/mailer-domain.state';

const selectMailerDomain = createFeatureSelector<IMailerDomainState>('mailerDomains');

export const getMailerDomainSuccess = createSelector(selectMailerDomain, (state: IMailerDomainState) => state.success);

export const getMailerDomainError = createSelector(selectMailerDomain, (state: IMailerDomainState) => state.error);

export const getPaginatedMailerDomains = createSelector(selectMailerDomain, (state: IMailerDomainState) => state.paginatedMailerDomains);
